export const SET_RANK = 'SET_RANK';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_BOOK = 'SET_BOOK';
